import { render, staticRenderFns } from "./TopProductChart.vue?vue&type=template&id=23158813&scoped=true"
import script from "./TopProductChart.vue?vue&type=script&lang=js"
export * from "./TopProductChart.vue?vue&type=script&lang=js"
import style0 from "./TopProductChart.vue?vue&type=style&index=0&id=23158813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23158813",
  null
  
)

export default component.exports